module.exports = __webpack_public_path__ + "assets/img/question-gray.cd070952.svg";